import React from "react";
import { Link } from "react-router-dom";

export default function VeteransSection({ api }) {
  const track = "veterans";
  const t = api?.t || {};
  const lang = api?.lang || "en";
  const cfg = t?.programTracks?.veterans || {};

  const returnTo = "/?noIntro=1#veterans-intake";

  const heading = cfg.heading || "Veteran & Military Support Programs";
  const startIntake = cfg.startIntake || "Start intake";
  const blurb = cfg.blurb || "If you’re a veteran, service member, or military family, WOW50/50 helps you move from “where I am now” to a clear next step — training, job placement, business growth, and community support.";
  const helpTitle = cfg.helpTitle || "How we can help";
  const helpBullets = Array.isArray(cfg.helpBullets) && cfg.helpBullets.length ? cfg.helpBullets : ["Build a training + job plan that fits your background (skills → placement → retention).", "Start or grow a veteran-owned business (marketing, operations, marketplace access).", "Transition support (reintegration, housing-stability connections, re-entry support).", "SDVOSB / VOSB readiness guidance (positioning + steps; not certification).", "Warm connections to partner employers and community organizations."];
  const unlocksTitle = cfg.unlocksTitle || "Unlocks";
  const unlocksBullets =
    Array.isArray(cfg.unlocksBullets) && cfg.unlocksBullets.length
      ? cfg.unlocksBullets
      : [];
  const notes = cfg.notes || "";
  const trackLabel = cfg.trackLabel || "Veteran & Military Support";
  const partnersTitle = cfg.partnersTitle || "For partners & community organizations";
  const partnersBody1 = cfg.partnersBody1 || "This track is designed for measurable outcomes: training enrollments, placement, and ongoing support.";
  const partnersBody2 = cfg.partnersBody2 || "Our intake and routing workflow helps veterans get to the right resource quickly.";

  const options = Array.isArray(cfg.options) && cfg.options.length
    ? cfg.options
    : [
        { id: "employment", label: "Training + job placement" },
                { id: "business-support", label: "Start / grow a veteran-owned business" },
                { id: "transition", label: "Transition / reintegration support" },
                { id: "sdvosb-vosb", label: "SDVOSB / VOSB readiness" },
                { id: "partnerships", label: "Employer / agency partnership" }
      ];

  return (
    <section id="veterans" className="scroll-mt-24 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
          {heading}
        </h2>

        <Link
          to={`/intake?track=${encodeURIComponent(track)}&return=${encodeURIComponent(returnTo)}&lang=${encodeURIComponent(lang)}`}
          className="ml-auto inline-flex items-center justify-center rounded-full border border-emerald-400/30 bg-emerald-500/10 px-4 py-2 text-sm font-semibold text-emerald-200 hover:bg-emerald-500/15 transition"
        >
          {startIntake}
        </Link>
      </div>

      <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
        <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
          {blurb}
        </p>

        <div className="grid gap-3 md:grid-cols-2">
          <div id="veterans-intake" className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{helpTitle}</div>
            <ul className="mt-2 list-disc pl-5 text-sm text-slate-200 space-y-1">
              {helpBullets.map((b, idx) => (
                <li key={idx}>{b}</li>
              ))}
            </ul>

            {unlocksBullets.length ? (
              <div className="mt-4 rounded-2xl border border-slate-800 bg-[#010916]/60 p-4">
                <div className="text-sm font-semibold text-slate-100">
                  {unlocksTitle}
                </div>
                <ul className="mt-2 list-disc pl-5 text-sm text-slate-200 space-y-1">
                  {unlocksBullets.map((b, idx) => (
                    <li key={idx}>{b}</li>
                  ))}
                </ul>
                {notes ? (
                  <div className="mt-3 text-xs text-slate-300">{notes}</div>
                ) : null}
              </div>
            ) : notes ? (
              <div className="mt-3 text-xs text-slate-300">{notes}</div>
            ) : null}
          </div>

          <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{partnersTitle}</div>
            <div className="mt-2 text-sm text-slate-200 space-y-2">
              <p>{partnersBody1}</p>
              <p>{partnersBody2}</p>
            </div>
          </div>
        </div>
      </div>
    
      <div className="mt-6 rounded-2xl border border-slate-800 bg-[#010916]/70 p-4">
        <div className="text-sm font-semibold text-slate-100">Member Intake (required)</div>
        <p className="mt-1 text-xs text-slate-300">
          To request personalized support under this program, you must be an active WOW50/50 member and logged in.
        </p>
        <div className="mt-3">
          <Link
            to={"/intake?track=" + encodeURIComponent(track)}
            className="inline-flex items-center justify-center rounded-xl border border-cyan-400/40 bg-cyan-500/10 px-4 py-2 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/15"
          >
            Go to Member Intake
          </Link>
        </div>
      </div>
</section>
  );
}
